export class Address {

  readonly city: string;

  readonly state: string;

  readonly street: string;

  readonly zipCode: string;

  static fromJSON(jsonObject: any): Address {
    const result = Object.create(Address.prototype);
    return Object.assign(result, jsonObject);
  }

  getCityStateZip(): string {
    return (this.city ? this.city : '') + (this.city && (this.state || this.zipCode) ? ', ' : '') + (this.state ? this.state : '') + (this.state && this.zipCode ? ' ' : '') + (this.zipCode ? this.zipCode : '');
  }

}
